import { render, staticRenderFns } from "./BaseLottiePlayer.vue?vue&type=template&id=662f2d5c&"
import script from "./BaseLottiePlayer.vue?vue&type=script&lang=js&"
export * from "./BaseLottiePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports